import {
  CleanTournament,
  TournamentParticipant,
} from '../../domain/models/tournament.model';
import { Action } from '../action.type';
export const RETRIEVE_TOURNAMENTS = 'RETRIEVE_TOURNAMENTS';
export const RETRIEVE_TOURNAMENTS_SUCCESS = 'RETRIEVE_TOURNAMENTS_SUCCESS';
export const RETRIEVE_TOURNAMENTS_FAILURE = 'RETRIEVE_TOURNAMENTS_FAILURE';

export const RETRIEVE_TOURNAMENTS_BY_USER = 'RETRIEVE_TOURNAMENTS_BY_USER';
export const RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS =
  'RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS';
export const RETRIEVE_TOURNAMENTS_BY_USER_FAILURE =
  'RETRIEVE_TOURNAMENTS_BY_USER_FAILURE';

export const RETRIEVE_TOURNAMENTS_CREATED_BY_USER =
  'RETRIEVE_TOURNAMENTS_CREATED_BY_USER';
export const RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS =
  'RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS';
export const RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE =
  'RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE';

export const RETRIEVE_TOURNAMENT_DETAILS = 'RETRIEVE_TOURNAMENT_DETAILS';
export const RETRIEVE_TOURNAMENT_DETAILS_SUCCESS =
  'RETRIEVE_TOURNAMENT_DETAILS_SUCCESS';
export const RETRIEVE_TOURNAMENT_DETAILS_FAILURE =
  'RETRIEVE_TOURNAMENT_DETAILS_FAILURE';

export const RETRIEVE_GLOBAL_TOURNAMENT_DETAILS =
  'RETRIEVE_GLOBAL_TOURNAMENT_DETAILS';
export const RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS =
  'RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS';
export const RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE =
  'RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE';

export type RetrieveTournamentsPayload = {
  token: string;
  retry: number;
};

export type RetrieveTournamentsSuccessPayload = {
  tournaments: CleanTournament[];
};

export type RetrieveTournamentsByUserPayload = {
  token: string;
  retry: number;
};

export type RetrieveTournamentsByUserSuccessPayload = {
  userTournaments: CleanTournament[];
};

export type RetrieveTournamentsCreatedByUserPayload = {
  token: string;
  retry: number;
};

export type RetrieveTournamentsCreatedByUserSuccessPayload = {
  userTournaments: CleanTournament[];
};

export type RetrieveTournamentDetailsPayload = {
  token: string;
  tournamentId: string;
  seasonIds: string[];
  retry: number;
};

export type RetrieveGlobalTournamentDetailsPayload = {
  token: string;
  limit: number;
  year?: number;
  seasonId?: string;
  retry: number;
};

export type RetrieveGlobalTournamentDetailsSuccessPayload = {
  tournamentDetails: TournamentParticipant[];
};

export type RetrieveTournamentDetailsSuccessPayload = {
  tournamentDetails: TournamentParticipant[];
};

export interface RetrieveTournaments
  extends Action<RetrieveTournamentsPayload> {
  type: typeof RETRIEVE_TOURNAMENTS;
  payload: RetrieveTournamentsPayload;
}

export interface RetrieveTournamentsSuccess
  extends Action<RetrieveTournamentsSuccessPayload> {
  type: typeof RETRIEVE_TOURNAMENTS_SUCCESS;
  payload: RetrieveTournamentsSuccessPayload;
}

export interface RetrieveTournamentsFailure extends Action<string> {
  type: typeof RETRIEVE_TOURNAMENTS_FAILURE;
  payload: string;
}

export interface RetrieveTournamentsByUser
  extends Action<RetrieveTournamentsByUserPayload> {
  type: typeof RETRIEVE_TOURNAMENTS_BY_USER;
  payload: RetrieveTournamentsByUserPayload;
}

export interface RetrieveTournamentsByUserSuccess
  extends Action<RetrieveTournamentsByUserSuccessPayload> {
  type: typeof RETRIEVE_TOURNAMENTS_BY_USER_SUCCESS;
  payload: RetrieveTournamentsByUserSuccessPayload;
}

export interface RetrieveTournamentsByUserFailure extends Action<string> {
  type: typeof RETRIEVE_TOURNAMENTS_BY_USER_FAILURE;
  payload: string;
}

export interface RetrieveTournamentsCreatedByUser
  extends Action<RetrieveTournamentsCreatedByUserPayload> {
  type: typeof RETRIEVE_TOURNAMENTS_CREATED_BY_USER;
  payload: RetrieveTournamentsCreatedByUserPayload;
}

export interface RetrieveTournamentsCreatedByUserSuccess
  extends Action<RetrieveTournamentsCreatedByUserSuccessPayload> {
  type: typeof RETRIEVE_TOURNAMENTS_CREATED_BY_USER_SUCCESS;
  payload: RetrieveTournamentsCreatedByUserSuccessPayload;
}

export interface RetrieveTournamentsCreatedByUserFailure
  extends Action<string> {
  type: typeof RETRIEVE_TOURNAMENTS_CREATED_BY_USER_FAILURE;
  payload: string;
}

export interface RetrieveTournamentDetails
  extends Action<RetrieveTournamentDetailsPayload> {
  type: typeof RETRIEVE_TOURNAMENT_DETAILS;
  payload: RetrieveTournamentDetailsPayload;
}

export interface RetrieveTournamentDetailsSuccess
  extends Action<RetrieveTournamentDetailsSuccessPayload> {
  type: typeof RETRIEVE_TOURNAMENT_DETAILS_SUCCESS;
  payload: RetrieveTournamentDetailsSuccessPayload;
}

export interface RetrieveTournamentDetailsFailure extends Action<string> {
  type: typeof RETRIEVE_TOURNAMENT_DETAILS_FAILURE;
  payload: string;
}

export interface RetrieveGlobalTournamentDetails
  extends Action<RetrieveGlobalTournamentDetailsPayload> {
  type: typeof RETRIEVE_GLOBAL_TOURNAMENT_DETAILS;
  payload: RetrieveGlobalTournamentDetailsPayload;
}

export interface RetrieveGlobalTournamentDetailsSuccess
  extends Action<RetrieveGlobalTournamentDetailsSuccessPayload> {
  type: typeof RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_SUCCESS;
  payload: RetrieveGlobalTournamentDetailsSuccessPayload;
}

export interface RetrieveGlobalTournamentDetailsFailure extends Action<string> {
  type: typeof RETRIEVE_GLOBAL_TOURNAMENT_DETAILS_FAILURE;
  payload: string;
}
